import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import List from "Components/List/List";
import FlexRow from "Components/FlexRow";
import DotsIcon from "Assets/SVG/DotsIcon";
import { IPrintPlacementDto } from "Apis/Models/IPrintDto";

interface IProps {
    printPlacements?: IPrintPlacementDto[];
    isLoading: boolean;
}
const PrintPlacementList = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { printPlacements, isLoading } = props;
    
    const navigate = useNavigate();
    
    return (
        <List<IPrintPlacementDto> data={printPlacements} loading={isLoading} columns={[
            {
                title: t('name'),
                textRender: (record) => record.name
            },
            {
                title: t('functions'),
                size: "min-content",
                customRender: (record) => <FlexRow className={"h-100 clickable"} justify={"center"} onClick={() => navigate(`/prints/placement/edit/${record.id}`)} ><DotsIcon /></FlexRow>
            }
        ]} keyExtractor={(record) => record.id.toString()} />
    )
}

export default PrintPlacementList
